export default "__VITE_ASSET__9abe4c62__"